import { FAILED } from './useFileUploads';

/**
 * Everything the Image Q draws, in slide order:
 * - `slide`: a downloaded slide
 * - `loading`: a slide the room has listed whose image is still downloading
 * - `upload`: one of this user's uploads, standing in for the slides it will
 *   become until they have all downloaded
 *
 * An upload claims its slides: once the server has said which ones it
 * created, by name, and before that, the index it asked for. A claimed slide
 * is left out, so the room's refresh can't put a second tile next to the
 * upload's own, and a document's pages appear together rather than one by one.
 * A failed upload claims nothing.
 */
export default function imageQItems({ slides = [], loadingSlides = [], uploads = [], sortAsc = true }) {
    const active = uploads.filter(({ status }) => status !== FAILED);
    const claimedNames = new Set(active.flatMap(({ added = [] }) => added.map(({ itemName }) => itemName)));
    const claimedIndexes = new Set(
        active.filter(({ added = [] }) => !added.length).map(({ index }) => index)
    );
    const unclaimed = ({ itemName, index }) => !claimedNames.has(itemName) && !claimedIndexes.has(index);

    const items = [
        ...slides.filter(unclaimed).map((slide) => ({ type: 'slide', key: `slide-${slide.itemName}`, index: slide.index, slide })),
        ...loadingSlides.filter(unclaimed).map((slide) => ({ type: 'loading', key: `slide-${slide.itemName}`, index: slide.index, slide })),
        ...uploads.map((upload) => ({ type: 'upload', key: `upload-${upload.id}`, index: upload.index, upload }))
    ];
    // An upload has no index for the instant before its request goes out;
    // keep it at the end it's about to land on.
    const position = ({ index }) => (index == null ? Infinity : +index);
    return items.sort((a, b) => (sortAsc ? position(a) - position(b) : position(b) - position(a)));
}
